export const ERROR_CODES_LIST_TO_SHOW_ONE_BUTTON_MODAL = ['003', 'unknown_error_occured']
export const ERROR_CODES_LIST_TO_SHOW_TWO_BUTTONS_MODAL = ['store_web_orders', 'unknown_error_occured', 'error_inactivestore', 'No_Profile', '003']
export const PAGES_LIST_THAT_EXCLUDED_FROM_PROCESSING = ['quote']
